import { useCallback } from "react"
import useRequestCatcher from "../../../../../../hooks/useRequestCatcher"
import { useNavigate } from "react-router-dom"

export default function useUploadDocumentsHandler({
    id,
    deleteItem,
    uploadItems,
    fetchInvoiceData,
} = {}){

    const requestCatcher = useRequestCatcher()

    const submitHandler = useCallback(async(payloadId, payload) => {
        return await requestCatcher({
            id: payloadId,
            payload,
            requestHandler: uploadItems,
            onSuccessMessage: 'Successfully attached files',
            onSuccessCallback: () => fetchInvoiceData?.({ id }),
        })
    }, [uploadItems, fetchInvoiceData])

    const deleteHandler = useCallback(async(payloadId) => {
        return await requestCatcher({
            id: payloadId,
            requestHandler: deleteItem,
            onSuccessMessage: 'Successfully removed attached file',
            onSuccessCallback: () => fetchInvoiceData?.({ id }),
        })
    }, [deleteItem, fetchInvoiceData])

    return {
        submitHandler,
        deleteHandler
    }
}